<template>
  <div class="register absolute">
    <div class="register_tit">
      <img @click="$router.go(-1)" src="../../assets/images/licai/fanhui.png" />
      <p class="">{{ $t("m.jf_span11") }}</p>
    </div>
    <div class="register_block">
      <div
        style="border-radius:8px;background:#fff;padding:0px 10px 25px 10px;font-size:14px;"
      >
        <div
          style="display:flex;align-items:center;border-bottom:1px solid #eee;height: 45px;"
        >
          <span style="width: 100px;font-weight:blod;color:#000;">{{
            $t("m.jf_span12")
          }}</span>
          <input type="text" v-model="name" placeholder="" />
        </div>
        <div
          style="display:flex;align-items:center;border-bottom:1px solid #eee;height: 45px;"
        >
          <span style="width: 100px;font-weight:blod;color:#000;">{{
            $t("m.jf_span13")
          }}</span>
          <input type="text" v-model="phone" placeholder="" />
        </div>
        <div
          style="display:flex;align-items:center;border-bottom:1px solid #eee;height: 45px;"
          @click="diquBtn()"
        >
          <span style="width: 100px;font-weight:blod;color:#000;">{{
            $t("m.jf_span14")
          }}</span>
          <input type="text" v-model="diqu" placeholder="" />
        </div>
        <div
          style="display:flex;align-items:center;border-bottom:1px solid #eee;height: 45px;"
        >
          <span style="width: 100px;font-weight:blod;color:#000;">{{
            $t("m.jf_span15")
          }}</span>
          <input type="text" v-model="address" placeholder="" />
        </div>
        <!-- <div style="height: 44px;line-height:44px;border-radius:22px;margin-top:20px; background:#FF4D33;color:#fff;font-weight:blod;font-size:17px;text-align:center;">保存地址</div> -->
      </div>

      <!-- <div style="border-radius:8px;background:#fff;padding:15px 10px 15px 15px;display:flex;align-items:center;position: relative;">
            <span style="position: absolute;right:10px;top:10px;color:#666;font-size:14px;">编辑</span>
            <div style="flex:1;margin-right:10px;">
                <div style="display:flex;align-items:center;">
                    <span style="color:#000;font-weight:bold;font-size:18px;margin-right:10px;">姚小帅</span>
                    <span style="color:#666;font-size:13px;">17681552082</span>
                </div>
                    <p style="margin-top:10px;font-size:14px;color:#000;">四川省陕西是农业由司法部思考，00000四川省陕西是农业由司法部思考，00000四川省陕西是农业由司法部思考，00000</p>
            </div>
            <img src="../../assets/images/licai/right.png" style="width: 20px;height: 20px;" alt="">
         </div> -->
      <div
        style="border-radius:8px;background:#fff;padding:10px 10px 50px 10px;margin-top:10px;"
      >
        <div
          style="font-size:20px;line-height:30px;color:#000;margin-bottom:10px;"
        >
          {{ $t("m.jf_span16") }}
        </div>
        <div style="display:flex;">
          <img
            :src="dicdata1.images"
            style="width: 100px;height: 100px;border-radius:8px;margin-right:10px;"
            alt=""
          />
          <div style="position: relative;flex:1;">
            <div style="font-size:17px;color:#000;" class="line-clamp2">
              {{ dicdata1.title }}
            </div>
            <div
              style="position: absolute;left:0px;bottom:0px;color:#666;font-size:13px;"
            >
              <span style="font-size:20px;color:red;font-weight:bold;"
                >{{ dicdata1.price }} </span
              >{{ $t("m.dj_span5") }}
            </div>
          </div>
        </div>
        <div
          style="display:flex;align-items:center;font-size:14px;margin-top:20px;"
        >
          <span style="width: 105px;color:#000;">{{ $t("m.jf_span5") }}</span>
          <span style="color:#666">{{ dicdata1.sketch }}</span>
        </div>
        <div
          style="display:flex;align-items:center;font-size:14px;height: 40px;"
        >
          <span style="width: 105px;color:#000;">{{ $t("m.jf_span6") }}</span>
          <span style="color:#666">{{ dicdata.num }}</span>
        </div>
        <div style="display:flex;align-items:center;font-size:14px;">
          <span style="width: 105px;color:#000;">{{ $t("m.jf_span7") }}</span>
          <span style="color:#666;flex:1;">{{ dicdata.bz }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="show"
      style="z-index: 1000; background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;"
    >
      <van-area
        style="position: absolute;left: 0;width: 100%;bottom: 0;"
        @cancel="cancel"
        @confirm="confirm"
        :title="$t('m.jf_span14')"
        :area-list="areaList"
      />
    </div>
    <div
      @click="wancheng"
      style="border-radius:4px 4px 0 0; width: 100%;position: fixed;bottom:0;left:0;height: 54px;line-height:54px; background:#FF4D33;color:#fff;font-weight:blod;font-size:17px;text-align:center;"
    >
      {{ $t("m.tijiao") }}
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
import { areaList } from "@vant/area-data";
export default {
  name: "JfPay",
  data: function() {
    return {
      show: false,
      areaList: areaList,
      diqu: "",
      name: "",
      phone: "",
      address: "",
      money: "",
      mima: "",
      dicdata: {},
      dicdata1: {}
    };
  },

  mounted: function() {
    this.dicdata = JSON.parse(localStorage.getItem("jifen"));

    let type = this.$route.params.id;
    request
      .get("/shop/goods/good-detail", { id: type }, { login: true })
      .then(res => {
        console.log(res);
        this.dicdata1 = res.data.data;
      })
      .catch(err => {
        this.$dialog.error(err.response.data.msg);
      });
  },
  methods: {
    confirm(e) {
      console.log(e);
      this.diqu = e[0].name + e[1].name + e[2].name;
      this.show = false;
    },
    cancel() {
      this.show = false;
    },
    diquBtn() {
      console.log("撒大声地");
      this.show = true;
    },
    wancheng() {
      if (this.name == "") {
        this.$dialog.message(this.$t("m.jf_span12"));
        return;
      }
      if (this.phone == "") {
        this.$dialog.message(this.$t("m.jf_span13"));
        return;
      }
      if (this.diqu == "") {
        this.$dialog.message(this.$t("m.jf_span14"));
        return;
      }
      if (this.address == "") {
        this.$dialog.message(this.$t("m.jf_span15"));
        return;
      }
      this.dicdata.name = this.name;
      this.dicdata.phone = this.phone;
      this.dicdata.address = this.address;
      this.dicdata.diqu = this.diqu;
      console.log(this.dicdata);
      localStorage.setItem("jifen", JSON.stringify(this.dicdata));

      let type = this.$route.params.id;

      request
        .post(
          "/shop/goods/add",
          {
            id: type,
            num: this.dicdata.num,
            phone: this.dicdata.phone,
            name: this.dicdata.name,
            address: this.diqu + this.address
          },
          { login: true }
        )
        .then(res => {
          console.log(res);
          this.$router.push({
            path: "/JfOver/" + type
          });
        })
        .catch(err => {
          this.$dialog.error(err.response.data.msg);
        });
    }
  }
};
</script>
<style scoped>
.line-clamp2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.register_block {
  padding: 10px;
}
.register_tit {
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
</style>
